import {
    RECOMMENTEDPRICE_ONCHANGE
} from '../Actions/Recommendedprice.action';

const DEFAULT_STATE = {
    isrecommendedprice:false
};

export const recommendedprice = (state = DEFAULT_STATE, action) => {
    const { type, payload } = action;
    switch (type) {     
        case RECOMMENTEDPRICE_ONCHANGE:
            return {                
                ...payload,
            };
        default:
            return state;
    }
};
